export var TicketStatus;
(function (TicketStatus) {
    TicketStatus["CREATED"] = "created";
    TicketStatus["AWAIT_USER_INPUT"] = "await_user_input";
    TicketStatus["AWAIT_OPERATOR_INPUT"] = "await_operator_input";
    TicketStatus["PENDING"] = "pending";
    TicketStatus["CLOSED"] = "closed";
})(TicketStatus || (TicketStatus = {}));
